<template lang="pug">
  .app
    router-view
    form(id="download" action="" method="GET" target="downloadFrame" style="display: none")
    iframe(id="downloadFrame" style="display: none")
</template>

<script>
import $ from 'jquery'
import { bus } from '@/service'

export default {
  name: 'app',
  mounted () {
    $('#initial-loader').hide()
    let self = this
    bus.$on('update_user', (user) => {
      self.$store.user = user
    })
    bus.$on('download', function (downloadPath) {
      $('#download').empty()
      if (downloadPath.indexOf('?') > -1) {
        let query = downloadPath.split('?')[1].split('=')
        let hidden = $('<input/>')
        hidden.attr('type', 'hidden')
        hidden.attr('name', query[0])
        hidden.attr('value', query[1])
        $('#download').append(hidden)
      }
      console.log('download:' + downloadPath)
      $('#download').attr('action', downloadPath)
      $('#download').submit()
      // postが必要な場合は別の$onを実装する
    })
  }
}
</script>

<style lang="stylus">
//-共通のスタイルはここへ記載する
body
  background-color: #fff
  padding-top: 0
h1, h2, h3, h4, h5, h6
  font-weight: bold
h3
  font-size: 18px
h2, h3, .h3
  margin-top: 20px
  font-size: 17px
  font-weight: bold
.x_content h4, .h4
  margin-top: 5px
p
  font-size: 15px
  margin: 0 0 10px
hr
  border-top: 1px solid #ddd
.nav-md, .container.body, .col-md-3, .left_col
  display: block
a:hover
  transition: 0.5s
.form-control
  border-radius: 3px
.form-control:focus, textarea:focus, select:focus
  border-color: #1abc9c
  outline: 0
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6) !important
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6)
label#control-label
  font-size: 18px
  margin-right: 10px
.fa-fw
  width: 2em
nav.navbar
  border-radius: 0
  border: 0
  height: 55px
.nav.navbar-nav>li>a
  margin-top: -5px
.navbar-custom
  background-color: #34495e
a.navbar-brand
  letter-spacing: 0.1em
  i.fa.fa-envelope-open-o
    margin-right: 10px
.col-md-3.left_col
  z-index: 1000
  position: fixed !important
.navbar-collapse.collapse
  margin-top: -15px
  margin-bottom: -15px
  padding-left: 0
//button
.btn-success, .btn-primary, .btn-info, .btn-danger
  padding: 10px 40px
  font-size: 15px
.btn-success:active:hover
  background-color: #1d8f77
  border-color: #0f6958
  background-image: none
.btn-primary:hover
  background-color: #286090
  border-color: #204d74
  background-image: none
.btn-info:hover
  background-color: #31b0d5
  border-color: #269abc
  background-image: none
.btn-warning:hover
  background-color: #ec971f
  border-color: #d58512
  background-image: none
.btn-danger:hover
  background-color: #c9302c
  border-color: #ac2925
  background-image: none
.btn-default
  background-image: none
.btn-right
  float: right
  margin-bottom: -15px !important
.setting-button
  margin-top: 20px
  text-align: center
//sidebar
.sidebar-footer
  a
    width: 50%
    color: #fff
    padding: 13px 0
.page-title .title_left h2
  padding: 40px 0 15px
  font-size: 20px
.profile_info
  width: 100%
  padding: 10px 13px
  p
    color:#fff
//フォームコントロール
.form-control
  border-radius: 3px !important
.form-control:focus, textarea:focus, select:focus
  border-color: #1abc9c
  outline: 0
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6) !important
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6)

// validation color
input[type=text].invalid, textarea.invalid, select.invalid, input[type=password].invalid
  border-color: #ff4e49
  border-width: 1px
  background-color: #ffe4e4
span.invalid
  color: #ff4e49

//入力チェックエラー
.error
  font-size: 14px
  display: inline-block
  position: relative
  background: #ff4e49
  border-radius: 3px
  color: #fff
  padding: 6px 10px
  margin-top: 5px
  &:after, &:before
    bottom: 100%
    left: 20%
    border: solid transparent
    content: " "
    height: 0
    width: 0
    position: absolute
    pointer-events: none
  &:after
    border-color: rgba(136, 183, 213, 0)
    border-bottom-color: #ff4e49
    border-width: 12px
    margin-left: -12px
  &:before
    border-bottom-color: #ff4e49
    border-width: 12px
    margin-left: -12px
  .fa
    margin-right: 5px
  p
    margin: 0
    pading: 0
    font-size: 13px
@media (max-width: 991px)
  .main_container
    overflow: auto !important
  .nav-md, .container.body, .col-md-3, .left_col
    display: block !important
//チャット共通
#chat-frame
  min-width: 320px
  max-width: 800px
  margin: auto
  padding: 1em 5px
  background-color: #d8f3f0
  border-radius: 5px
  height: 100%
  .customsmallbutton
    position: absolute
    bottom: 20px
    right: 45px
// チャットプレビュー画面
#chatpreviewmodal
  textarea
    width: 100%
    resize: vertical
  .signselect
    float: left
  .fa-stack
    font-size: 25px
    cursor: pointer
    &:hover
      opacity: 0.5
    .fa-stack-1x
      color: #fff
    .fa-paperclip
      margin: 1px 0px 0px 0px
    .fa-paper-plane-o
      margin: 1px 0px 0px -1px
    .fa-circle
      color: #26B99A

//colorpicker
.colorpicker-alpha
  display: none !important
.colorpicker-with-alpha
  min-width: 121px !important
</style>



// WEBPACK FOOTER //
// App.vue?edf657f4